export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "流動性マイニング",
    "加入节点， 开始挖矿": "ノードに参加してマイニングを開始",
    "参 与": "参加",
    "矿池数据": "プールデータ",
    "总产量": "総生産量",
    "有效节点": "有効なノード",
    "参与者": "参加者",
    "用户收入": "ユーザー収益",
    "挖矿榜单": "マイニングランキング",
    "流动性挖矿收入": "流動性マイニング収益",
    "输出记录": "出力記録",
    "地址": "アドレス",
    "数量": "数量",
    "帮助中心": "ヘルプセンター",
    "希望它可以帮助你": "役立つことを願っています",
    "安全保障": "セキュリティ保証",
    "我们有安全的审计报告": "安全な監査報告があります",
    "伙伴": "パートナー",
    "我们的商业伙伴": "私たちのビジネスパートナー",
    "首页": "ホーム",
    "我的矿池": "私のマイニングプール",
    "提取": "引き出し",
    "账户": "アカウント",
    "总挖矿金额": "総マイニング額",
    "可更换": "交換可能",
    "收益率": "利回り",
    "币池名称": "プール名",
    "最低金额": "最小額",
    "收益率/24小时": "利回り/24時間",
    "挖矿记录": "マイニング履歴",
    "金额": "金額",
    "描述": "説明",
    "时间": "時間",
    "已参与": "参加済み",
    "质 押": "ステーキング",
    "已质押": "ステーキング済み",
    "记录": "記録",
    "兑换": "交換",
    "从": "から",
    "全部": "すべて",
    "至": "まで",
    "价格": "価格",
    "确认": "確認",
    "矿池收益": "プール収益",
    "今日收益": "今日の収益",
    "普通矿池": "通常プール",
    "高级矿池": "高級プール",
    "全部的": "すべて",
    "可用的": "利用可能",
    "申请加入": "参加申し込み",
    "推荐朋友": "友達を招待",
    "一起赚取加密货币": "一緒に暗号通貨を稼ぐ",
    "查看详情": "詳細を見る",
    "团队": "チーム",
    "推荐": "推薦",
    "团队规模": "チーム規模",
    "直接发起人": "直接紹介者",
    "总收入": "総収益",
    "今天的收入": "今日の収益",
    "我的推荐链接": "私の推薦リンク",
    "复制": "コピー",
    "1. 获取链接": "1. リンクを取得",
    "2. 邀请朋友": "2. 友達を招待",
    "3. 赚取加密货币": "3. 暗号通貨を稼ぐ",
    "等级": "レベル",
    "1 级": "レベル 1",
    "2 级": "レベル 2",
    "3 级": "レベル 3",
    "用户地址": "ユーザーアドレス",
    "币种": "通貨種類",
    "说明": "説明",
    "状态": "ステータス",
    "定时收益": "定期収益",
    "今日预收益": "今日の予測収益",
    "累计收益": "累積収益",
    "将矿池收益的BNB兑换成USDT后立即到账": "プール収益のBNBをUSDTに変換して即座に受け取る",
    "将USDT提取后会在24小时内到达你的钱包": "USDTを引き出すと24時間以内にウォレットに届きます",
    "天": "日",
    "高级矿池收益": "高級プール収益",
    "质押收益": "ステーキング収益",
    "下次收益": "次回の収益",
    "当前收益率": "現在の利回り",
    "昨日收益": "昨日の収益",
    "普通矿池收益率": "通常プールの利回り",
    "高级矿池收益率": "高級プールの利回り",
    "高级矿池限时开放": "高級プール期間限定開放",
	"公告":"発表",
	"我知道了":"なるほど"
};
